var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewStatementWithBlueBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 15,
    fill: "#506994"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0338 17.4595C37.0338 16.4725 36.1518 15.5626 35.8997 15.3158L31.1113 10.751C30.4813 10.1341 29.9773 9.64062 28.9692 9.64062H16.7462C14.604 9.64062 12.8398 11.3679 12.8398 13.4652V36.536C12.8398 38.6334 14.604 40.3606 16.7462 40.3606H33.1275C35.2697 40.3606 37.0338 38.6334 37.0338 36.536V17.6599V17.4595ZM34.3876 36.536C34.3876 37.1529 33.8836 37.7698 33.1275 37.7698H16.7462C16.1161 37.7698 15.4861 37.2763 15.4861 36.536V13.4652C15.4861 12.8483 15.9901 12.2315 16.7462 12.2315H26.0709V18.5235C26.0709 19.6339 27.079 20.6209 28.2131 20.6209H34.3876V36.536ZM34.3876 17.9067H29.4732C29.0952 17.9067 28.8432 17.6599 28.8432 17.2898V12.2315C28.8432 12.2315 28.9692 12.3549 29.2212 12.6016L33.8836 17.1664C34.0096 17.2898 34.2616 17.5365 34.2616 17.6599V17.9067H34.3876Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0995 23.8281H20.0186C19.8099 23.8281 19.6406 23.9938 19.6406 24.1982V26.1722C19.6406 26.3766 19.8099 26.5424 20.0186 26.5424H30.0995C30.3082 26.5424 30.4775 26.3766 30.4775 26.1722V24.1982C30.4775 23.9938 30.3082 23.8281 30.0995 23.8281Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0995 28.5176H20.0186C19.8099 28.5176 19.6406 28.6833 19.6406 28.8877V30.8617C19.6406 31.0661 19.8099 31.2318 20.0186 31.2318H30.0995C30.3082 31.2318 30.4775 31.0661 30.4775 30.8617V28.8877C30.4775 28.6833 30.3082 28.5176 30.0995 28.5176Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewStatementWithBlueBox);
export default __webpack_public_path__ + "static/media/view_statement_with_blue_box.6a20b6be1bc1858e3099d659753d8535.svg";
export { ForwardRef as ReactComponent };